"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function SvgComponent(props) {
    const { fill = 'none' } = props, restProps = __rest(props, ["fill"]);
    return (react_1.default.createElement("svg", Object.assign({ "aria-hidden": 'true', focusable: 'false', className: `fl-${fill}`, width: 24, height: 24, viewBox: '0 0 24 24', xmlns: 'http://www.w3.org/2000/svg' }, restProps),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M5.46971 15.7365C5.20343 15.4703 5.17918 15.0536 5.39702 14.76L5.46963 14.6759L11.6714 8.4731C11.8272 8.31728 12.0796 8.3168 12.236 8.47203L18.5284 14.7177C18.8223 15.0095 18.8241 15.4844 18.5323 15.7784C18.267 16.0456 17.8505 16.0714 17.556 15.8546L17.4716 15.7823L12.2398 10.5907C12.0835 10.4355 11.831 10.436 11.6752 10.5917L6.53037 15.7364C6.26413 16.0027 5.84747 16.027 5.55384 15.8091L5.46971 15.7365Z' })));
}
exports.default = SvgComponent;
